<div class="font-lato">
  <ngx-sonner-toaster
    richColors
    [expand]="false"
    position="top-right"
    offset="16px"
    [toastOptions]="{
      style: {
        alignItems: 'flex-start',
        padding: '16px 16px 16px 16px',
        gap: '12px',
        position: 'relative',
        display: 'flex'
      },
      classes: {
        toast: 'flex items-start w-full relative',
        title: 'flex-1 pr-8',
        actionButton: 'mt-3 flex-shrink-0'
      }
    }"
    closeButton
  />
  <router-outlet></router-outlet>
</div>